/**
 * `POST /api/payments/preferences` — toggle a seller's per-rail payout flags.
 *
 * PATCH-style: each flag is independently optional on the request. Response
 * always returns the EFFECTIVE post-update state of all four fields — both
 * the user-toggled flag (`*_enabled`) and the technical readiness flag
 * (`*_connected`) derived from the underlying merchant account.
 *
 * `ok: true` is the shape's "I'm a success body" sentinel — same pattern as
 * other apiJson routes. It's NOT a discriminator (the route never returns
 * `ok: false`; failure goes through `apiError`). Keep the field so existing
 * clients that branch on it don't drift.
 *
 * @see app/api/payments/preferences/route.ts — handler
 * @see .tondocs/payments/API_RESPONSE_AUDIT.md §6
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface PaymentsPreferencesResponse {
  ok: true;
  paypal_enabled: boolean;
  stripe_enabled: boolean;
  paypal_connected: boolean;
  stripe_connected: boolean;
}

export const PaymentsPreferencesResponseSchema = pinned<PaymentsPreferencesResponse>()(
  z.object({
    ok: z.literal(true),
    paypal_enabled: z.boolean(),
    stripe_enabled: z.boolean(),
    paypal_connected: z.boolean(),
    stripe_connected: z.boolean(),
  }),
);
